import { inject, injectable } from "inversify";
import { ILogoutGateway, LogoutResponse } from "./LogoutGateway";
import { DITypes } from "@/core/@types/types";
import type { HttpClient } from "@/core/services/protocols/types";
import type { IStorage } from "@/core/plugins/storage/Storage";

const baseUrl = "/Home/DoLogout/";

@injectable()
export default class LogoutHttpGateway implements ILogoutGateway {
  @inject(DITypes.FINANCAS_HTTP_CLIENT)
  private httpClient?: HttpClient;

  @inject(DITypes.STORAGE)
  private storage!: IStorage;

  private onLogout() {
    this.storage.delete("token");
    window.location.reload();
  }

  async logout(): LogoutResponse {
    try {
      await this.httpClient?.post({ url: baseUrl });
    } finally {
      this.onLogout();
    }
  }
}
